import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { SORT_PARAMETERS } from '../../const/sort'
import { locationColStyles } from '../../const/tableColumnsSize'

const LocationCol = ({ classes, handleSortChange }) => {
  return {
    header: 'Location',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: locationColStyles,
    sortParameter: SORT_PARAMETERS.LOCATION,
    onSortingChange: handleSortChange,
    Cell: productValues => {
      const productData = productValues.data
      const isProductLoading = productValues.isLoading

      return isProductLoading ? <Skeleton width="100%" /> : productData?.location?.name || '-'
    }
  }
}

export default LocationCol
